export const baseEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const email =
    /^(?!.*gitated)[A-Z0-9_%+-]+(\.[A-Z0-9_%+-]{1,}){0,5}@(?!yahooresult|gspl|gsspl|GSPL|GSSPL)[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const excludePeriods = /^[^.]*$/;

export const companiesToExclude = /^.*(gspl|gsspl|mcdonalds|porn|touchbistro|touch bistro|forbes|any company).*$/i;

const expressions = [baseEmail, email, excludePeriods, companiesToExclude];

export default expressions;
